var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 25,
    height: 25,
    transform: "translate(414 172)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-414 -172)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M428.518,182.706a24.8,24.8,0,0,0-3.8-3.181c-1.4-.906-2.278-1.1-2.762-.62a.857.857,0,0,0-.2.322l-7.537,17.087a.489.489,0,0,0,.448.686.478.478,0,0,0,.195-.041L432,189.472a.846.846,0,0,0,.317-.2c.484-.484.287-1.361-.619-2.761A24.714,24.714,0,0,0,428.518,182.706Zm-1.236,7.761L426,189.18a.489.489,0,1,0-.692.691l1.016,1.016-4.8,2.1-3.308-3.308,2.111-4.788,2.219,2.219a.489.489,0,0,0,.691-.691l-2.487-2.487,1.354-3.07c.128.248.285.516.474.807a27.943,27.943,0,0,0,6.986,6.987c.289.187.555.343.8.47Zm.545-7.069a24.843,24.843,0,0,1,2.887,3.4,4.749,4.749,0,0,1,.88,1.754,4.776,4.776,0,0,1-1.754-.88,27.623,27.623,0,0,1-6.282-6.283,4.753,4.753,0,0,1-.881-1.754,4.76,4.76,0,0,1,1.754.88A24.92,24.92,0,0,1,427.827,183.4Zm-10.04,7.237,2.769,2.769-4.943,2.158Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M434.482,177.19c-.061-.354-.064-.472.034-.571s.217-.1.571-.034a1.489,1.489,0,0,0,1.429-.307.489.489,0,1,0-.691-.691c-.1.1-.217.1-.571.034a1.345,1.345,0,0,0-1.735,1.735c.061.355.064.473-.035.572s-.216.1-.571.034a1.344,1.344,0,0,0-1.734,1.735c.061.354.064.472-.035.571s-.216.1-.571.034a1.485,1.485,0,0,0-1.428.307.489.489,0,0,0,.691.691c.1-.1.217-.1.571-.035a1.345,1.345,0,0,0,1.735-1.735c-.061-.354-.064-.472.034-.571s.217-.1.571-.034a1.345,1.345,0,0,0,1.735-1.735Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M424.8,177.721a.488.488,0,0,0,.692,0,3.121,3.121,0,0,0,0-4.408.489.489,0,0,0-.692.691,2.141,2.141,0,0,1,0,3.026A.49.49,0,0,0,424.8,177.721Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M436.115,186.517a3.093,3.093,0,0,0-2.2.913.489.489,0,1,0,.691.691,2.139,2.139,0,0,1,3.026,0,.489.489,0,1,0,.691-.691A3.1,3.1,0,0,0,436.115,186.517Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M437.586,174.443a.488.488,0,0,0,.489-.488v-1.466a.489.489,0,1,0-.977,0v1.466A.487.487,0,0,0,437.586,174.443Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M428.862,175.425h.484v.485a.489.489,0,0,0,.978,0v-.485h.485a.489.489,0,0,0,0-.977h-.485v-.485a.489.489,0,1,0-.978,0v.485h-.484a.489.489,0,1,0,0,.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M438.339,178.891h-1.467a.488.488,0,1,0,0,.977h1.466a.488.488,0,0,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M435.161,184.853a1.466,1.466,0,1,0-1.466-1.467A1.468,1.468,0,0,0,435.161,184.853Zm0-1.955a.489.489,0,1,1-.488.488A.489.489,0,0,1,435.161,182.9Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M424.268,187.655a.489.489,0,1,0,0,.977h0a.489.489,0,1,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M435.21,189.6a.489.489,0,0,0,0,.978h0a.489.489,0,0,0,0-.978Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M438.143,181.774a.489.489,0,1,0,0,.977h0a.489.489,0,1,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M431.773,183.274a.489.489,0,1,0,0,.977h0a.489.489,0,1,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M427.835,178.4a.489.489,0,0,0,0,.977h0a.489.489,0,1,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M433.749,172.537a.489.489,0,0,0,0,.977h0a.489.489,0,1,0,0-.977Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M422.5,174.932a.489.489,0,0,0,0,.978h0a.489.489,0,0,0,0-.978Z",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessIcon);
export default __webpack_public_path__ + "static/media/sucessIcon.b434d66eb8eb926143e4f6411f20544f.svg";
export { ForwardRef as ReactComponent };